import EventEmitter from 'eventemitter3';
import $ from 'jquery';
import {find} from 'lodash';

// state/event names
export const IDLE = 'idle';
export const ACTIVE = 'active';

/**
 * Notifies subscribers of changes to ajax idle state.
 */
class Notifier extends EventEmitter {
  state = ACTIVE;

  /**
   * @param event
   * @param callback
   * @param {boolean} immediate indicates whether an event should be emitted immediately based on the current state;
   */
  on(...args) {
    const [event, callback, immediate] = args;

    if (event === this.state && immediate) {
      callback();
    }

    super.on(...args);
  }

  isActive() {
    return this.state === ACTIVE;
  }

  isIdle() {
    return this.state === IDLE;
  }
}
const ajaxRequestNotifier = new Notifier();

let idleThreshold;

let timeoutId;

let initialized = false;

let requestsToSkip = [];

const TEN_MINUTES_IN_MS = 10 * 60 * 1000;

/**
 * resets the notifier's current state and clears any pending notifications.
 */
export function reset() {
  idleThreshold = undefined;
  timeoutId = undefined;
  initialized = false;
  requestsToSkip = [];
  clearTimeout(timeoutId);
  ajaxRequestNotifier.state = ACTIVE;
  ajaxRequestNotifier.removeAllListeners();
}

/**
 * the single instance of @Notifier to use throughout the application
 */
export default ajaxRequestNotifier;

/**
 * @param {array} skipRequestDescriptors takes the form of {url, method} where url is a string or a regex used to match
 * requests which should be ignored when determining ajax idle state
 * @param idleThresholdMilliseconds how many milliseconds to wait before notifying subscribers that the ajax idle state
 * has changed to idle.
 */
export function init(
  skipRequestDescriptors = [],
  idleThresholdMilliseconds = TEN_MINUTES_IN_MS
) {
  if (initialized) {
    throw new Error(
      'Can only be initialized once; reset must be invoked in order to initialize again.'
    );
  } else {
    initialized = true;
  }

  requestsToSkip = skipRequestDescriptors;
  idleThreshold = idleThresholdMilliseconds;

  timeoutId = setTimeout(() => {
    ajaxRequestNotifier.state = IDLE;
    ajaxRequestNotifier.emit(IDLE);
  }, idleThreshold);

  $.ajaxPrefilter((options, originalOptions) => {
    const skipRequest = find(
      requestsToSkip,
      ({url, method}) =>
        originalOptions.url.match(url) &&
        (!method || method === (originalOptions.method || 'GET'))
    );

    if (!skipRequest) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (ajaxRequestNotifier.isIdle()) {
        ajaxRequestNotifier.state = ACTIVE;
        ajaxRequestNotifier.emit(ACTIVE);
      }

      timeoutId = setTimeout(() => {
        ajaxRequestNotifier.state = IDLE;
        ajaxRequestNotifier.emit(IDLE);
      }, idleThreshold);
    }
  });
}
